<hyperkit-typography variant="body" size="md" align="left" [color]="color"
  ><div [innerHTML]="html"></div>
</hyperkit-typography>
